@if (options.length > 0) {
  <div class="toggle-button-container" data-cy="toggle-button-container">
    <form [formGroup]="toggleButtonsForm">
      <div class="toggle-button-group">
        @for (option of options; track option) {
          <input type="radio"
            formControlName="option"
            id="{{option.code}}"
            [value]="option"
            [checked]="option.code === preSelectedOption?.code">
          <label for="{{option.code}}" class="toggle-button-option"
            [attr.data-cy]="'toggle-button-option-' + option.code">
            <div class="toggle-button-option-label-container">
              <div>{{option | prettyPrintDescription | undefinedValue}}</div>
              @if (option.extra) {
                <div>{{option.extra}}</div>
              }
            </div>
          </label>
        }
      </div>
    </form>
  </div>
}